import styled from 'styled-components'

export const BlogCreateDesignBannerContainer = styled.div`
  flex: 1;
  height: 380px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f5f0e8;
  box-sizing: border-box;
  margin-top: 93px;
  width: 100%;
  max-width: 1250px;

  @media (max-width: 1150px) {
    flex-direction: column;
    width: auto;
    max-width: 100%;
    margin-left: 15px;
    margin-right: 15px;
    height: auto;
    margin-top: 30px;
  }
`

export const BlogCreateDesignBannerImage = styled.img`
  width: 50%;
  height: 100%;

  @media (max-width: 1150px) {
    width: 100%;
  }
`

export const BlogCreateDesignBannerInfo = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 1150px) {
    width: 100%;
    padding: 30px 0;
  }
`

export const BlogCreateDesignBannerInfoTitle = styled.span`
  display: block;
  font-weight: 700;
  font-size: 48px;
  line-height: 59px;
  text-align: center;
  letter-spacing: 0.01em;

  @media (max-width: 1150px) {
    font-size: 24px;
    line-height: 29px;
    letter-spacing: 0.01em;
  }
`

export const BlogCreateDesignBannerInfoDescription = styled.span`
  display: block;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.01em;
  margin-top: 29px;
  margin-bottom: 31px;

  @media (max-width: 1150px) {
    font-weight: 500;
    font-size: 13px;
    line-height: 24px;
    letter-spacing: 0.01em;
    margin-top: 11px;
    margin-bottom: 14px;
  }
`

export const CreateDesignButton = styled.a`
  width: 216px;
  height: 48px;
  background: #ff5e6d;
  border-radius: 93px;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    270deg,
    #ff9d74 0%,
    #ff5e6d 37.4%,
    #ff4f7e 74.69%,
    #ff6d90 100%
  );

  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)),
      linear-gradient(
        270deg,
        #ff9d74 0%,
        #ff5e6d 37.4%,
        #ff4f7e 74.69%,
        #ff6d90 100%
      );
  }

  @media (max-width: 1150px) {
    width: 188px;
    height: 40px;
    padding: 0;
  }
`
